<template>
  <div class="container-fluid position-relative">
    <div class="row align-items-center mt-4 mt-lg-5 mb-2" v-if="show_div">
      <div class="col-12 col-lg-8 text-left px-0">
        <div
          class="w-100 d-flex align-items-end justify-content-between justify-content-lg-start"
        >
          <span class="rails-header-title">{{ title }}</span>
          <div
            class="d-flex flex-row align-items-center ml-3"
            v-if="showMore"
            @click="viewMore()"
          >
            <span class="see-more-text cursor-pointer">Lihat Semua</span>
            <div
              style="width: 24px;height: 24px;"
              class="d-flex align-items-center ml-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
              >
                <path
                  d="M12.293 5.33478C12.4806 5.14731 12.7349 5.04199 13 5.04199C13.2652 5.04199 13.5195 5.14731 13.707 5.33478L19.707 11.3348C19.8945 11.5223 19.9998 11.7766 19.9998 12.0418C19.9998 12.3069 19.8945 12.5613 19.707 12.7488L13.707 18.7488C13.5184 18.9309 13.2658 19.0317 13.0036 19.0295C12.7414 19.0272 12.4906 18.922 12.3052 18.7366C12.1198 18.5512 12.0146 18.3004 12.0124 18.0382C12.0101 17.776 12.1109 17.5234 12.293 17.3348L17.586 12.0418L12.293 6.74878C12.1056 6.56125 12.0002 6.30694 12.0002 6.04178C12.0002 5.77661 12.1056 5.52231 12.293 5.33478ZM6.29303 5.33478C6.48056 5.14731 6.73487 5.04199 7.00003 5.04199C7.26519 5.04199 7.5195 5.14731 7.70703 5.33478L13.707 11.3348C13.8945 11.5223 13.9998 11.7766 13.9998 12.0418C13.9998 12.3069 13.8945 12.5613 13.707 12.7488L7.70703 18.7488C7.51843 18.9309 7.26583 19.0317 7.00363 19.0295C6.74143 19.0272 6.49062 18.922 6.30521 18.7366C6.1198 18.5512 6.01463 18.3004 6.01236 18.0382C6.01008 17.776 6.11087 17.5234 6.29303 17.3348L11.586 12.0418L6.29303 6.74878C6.10556 6.56125 6.00024 6.30694 6.00024 6.04178C6.00024 5.77661 6.10556 5.52231 6.29303 5.33478Z"
                  fill="#D9E021"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row latest-video-v2-content" id="landscapeVODCarouselv1">
      <div class="owl-carousel owl-theme" :id="titleCarousel">
        <div
          class="item"
          v-for="item_vod in items"
          :key="titleCarousel + ' - ' + item_vod.id"
          @mouseover="mouseOver"
          @mouseout="mouseOver"
        >
          <vod-card
            :image="rtmImgLinkFiltering(item_vod.data.images, '200x0')"
            :title="item_vod.longTitle"
            :link="getAssetLink(item_vod)"
            :latestTag="formatTimestamp(item_vod.dateAvailability)"
            :data="item_vod.data"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import vodCard from "../cards/v2/vodCard.vue";
import ChevronRight from "../../assets/rtmklik/svg/theme_chevron_right.svg";
import ChevronLeft from "../../assets/rtmklik/svg/theme_chevron_left.svg";
import noimage from "../../assets/noimage.png";
export default {
  name: "vod-rails-landscape-new",
  props: ["title", "datasource", "cat", "cat_id", "show_rails"],
  data: function() {
    return {
      items: [],
      titleCarousel: this.title.replace(/\s/g, "").toLowerCase(),
      noimage: noimage,
      showMore: false,
      contenttype: this.datasource,
      hover: false,
      show_div: this.show_rails,
    };
  },
  components: { vodCard },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },
    formatString(str) {
      var lower = str.toLowerCase();
      return lower
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    viewMore() {
      this.$router.replace("/viewall/category/" + this.cat_id);
    },
    goTo(link) {
      this.$router.push(link);
    },

    checkIndexForMore() {
      var listlength = this.items;
      if (listlength.length > 0) {
        this.show_div = true;
      } else {
        this.show_div = false;
      }

      if (listlength.length > 8) {
        this.showMore = true;
      }
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 6,
        autoplay: false,
        loop: false,
        nav: false,
        dots: false,
        stagePadding: 0,
        responsiveClass: true,
        navText: [`<img src=${ChevronLeft} />`, `<img src=${ChevronRight} />`],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            margin: 8,
            stagePadding: 0,
          },
          768: {
            items: 4,
            stagePadding: 0,
            loop: false,
            margin: 8,
            nav: false,
          },
          992: {
            items: 5,
            stagePadding: 0,
            loop: false,
            margin: 6,
            nav: true,
          },
          1280: {
            items: 6,
            stagePadding: 2,
            loop: false,
            margin: 8,
            nav: true,
          },
        },
      });
    },
    async initializeContentForStart() {
      var vm = this;

      let urlLink =
        vm.cat_id == "365"
          ? `https://rtm.glueapi.io/v3/content?idSchema=2007&sort=-dateAvailability&idApp=1`
          : `https://rtm.glueapi.io/v3/content?fieldPath=categories&idSchemas=2003,2004,2005,2007,2009&fieldValue=${
              vm.cat_id
            }&sort=-dateAvailability&idApp=1`;

      let response = await axios.get(urlLink, {
        responseType: "json",
      });

      vm.items = response.data.data;
      var target = document.getElementById(vm.titleCarousel);
      if (vm.items) {
        vm.checkIndexForMore();
        Vue.nextTick(
          function() {
            vm.installOwlCarousel(target);
          }.bind(vm)
        );
      }
    },
  },
  beforeMount() {
    setTimeout(
      function() {
        this.initializeContentForStart();
      }.bind(this),
      1000
    );
  },
};
</script>

<style>
.latest-video-v2-content .owl-theme .owl-stage-outer {
  overflow: unset;
}
#landscapeVODCarouselv1 .owl-nav {
  display: none;
}

button:focus {
  outline: unset !important;
}

@media only screen and (min-width: 992px) {
  #landscapeVODCarouselv1 .owl-theme:hover {
    z-index: 111;
  }

  #landscapeVODCarouselv1 .owl-theme {
    height: auto;
  }
  #landscapeVODCarouselv1 .owl-item {
    z-index: 1;
  }
  #landscapeVODCarouselv1 .owl-item:hover {
    transition: 0.1s all ease-in-out;
    transform: scale(1.2);
    z-index: 2000;
  }

  #landscapeVODCarouselv1 .owl-theme .owl-nav.disabled {
    display: none !important;
  }
  #landscapeVODCarouselv1 .owl-theme .owl-nav {
    position: absolute;
    top: -48px;
    right: 2px;
    width: 80px;
    display: flex;
    justify-content: space-between;
  }

  #landscapeVODCarouselv1 .owl-prev img {
    width: 22px;
    height: 23px;
  }

  #landscapeVODCarouselv1 .owl-next img {
    width: 22px;
    height: 23px;
  }
}
</style>
